// extracted by mini-css-extract-plugin
module.exports = {"checkboxReplacement":"OrderControl_checkboxReplacement__iZA8J"};